const Home = () => {
  return <div className="w-full p-6 min-h-[calc(100vh-6rem)]">Home</div>;
};

export default Home;
